import type { AdminPublic } from '@cookspace-shared-contracts/core';

import type { AppDispatch } from '@/store';
import { useAppDispatch, useAppSelector } from '@/store';
import {
    selectAdmin,
    selectIsAuthenticated,
    selectIsAuthLoading } from '@/store/slices/authSlice';

interface UseAuthResult {
    admin: AdminPublic | null;
    isAuthenticated: boolean;
    isLoading: boolean;
    dispatch: AppDispatch;
}

export function useAuth(): UseAuthResult {
    const admin = useAppSelector(selectAdmin);
    const isAuthenticated = useAppSelector(selectIsAuthenticated);
    const isLoading = useAppSelector(selectIsAuthLoading);
    const dispatch = useAppDispatch();

    return { admin, isAuthenticated, isLoading, dispatch };
}
